import { BookOpen, Sparkles, ShieldCheck } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Primitives";
import { VALUES } from "@/data/site";

const ICONS = { BookOpen, Sparkles, ShieldCheck };

export const Values = () => {
  return (
    <section id="werte" className="relative py-24 lg:py-36 bg-charcoal text-cream overflow-hidden">
      <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 h-72 w-72 rounded-full bg-gold/10 blur-3xl" />
      <div className="relative mx-auto max-w-6xl px-6 lg:px-10 text-center">
        <Reveal>
          <Eyebrow className="text-gold-soft justify-center">
            <span className="text-gold-soft">Warum meine Praxis?</span>
          </Eyebrow>
          <h2 className="mt-6 font-serif font-light tracking-tight text-4xl sm:text-5xl lg:text-6xl">
            Wissen · Erfahrung · Vertrauen
          </h2>
          <p className="mt-6 max-w-xl mx-auto text-cream/70 leading-relaxed font-light">
            Drei Werte, die jede Begegnung in meiner Praxis prägen.
          </p>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-10 lg:gap-14">
          {VALUES.map((v, i) => {
            const Icon = ICONS[v.icon];
            return (
              <Reveal key={v.id} delay={i * 0.12}>
                <div data-testid={`value-${v.id}`} className="flex flex-col items-center">
                  <div className="h-20 w-20 rounded-full border border-gold/40 flex items-center justify-center">
                    <Icon size={30} strokeWidth={1} className="text-gold-soft" />
                  </div>
                  <h3 className="mt-7 font-serif text-3xl font-light">{v.title}</h3>
                  <p className="mt-4 text-sm text-cream/70 leading-relaxed max-w-xs font-light">{v.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
